import { handleRedirectOnCondition } from '@/exceed';

import handleAdminVideoAxiosError from './handleAdminVideoAxiosError';

export default ({ orgId, type, error, conditionedQueryCache }) => {
  const redirectUrl = `/videos/organizations/${orgId}/${type}/unauthorized`;
  const isForbidden = error.response?.status === 403;
  const condition =
    isForbidden ||
    ([conditionedQueryCache].status === 'success' && ![conditionedQueryCache].data.has_editor_permission);

  handleRedirectOnCondition({ condition, redirectUrl });
  
  if (!isForbidden) handleAdminVideoAxiosError(error);
}
